import { Box, Breadcrumbs, Typography } from '@mui/material';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AppsHeader from '@tenant/core/AppsContainer/AppsHeader';
import AppTooltip from '@tenant/core/AppTooltip';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IntlMessages from '@tenant/utility/IntlMessages';
import { ROUTE_STRING } from 'constants/RouteString';
import { Formik } from 'formik';
import validationSchema from '../../redux/slices/dockerImage/constants/validationSchema';
import DockerAppTypes from 'constants/DockerAppTypes';
import useAddDockerImage from 'redux/slices/dockerImage/hooks/useAddDockerImage';
import AddDockerImageForm from './components/Common/AddDockerImageForm';
import AppsContainer from '@tenant/core/AppsContainer';

const Add = () => {
  const navigate = useNavigate();
  const onClickBackButton = () => {
    navigate(ROUTE_STRING.DOCKER_IMAGE.LIST);
  };
  const addItem = useAddDockerImage();

  const handleSubmit = (data) => {
    addItem.mutate(
      {
        ...data,
        AppModel: undefined,
        DeploymentType: data.DeploymentType?.Value,
        TargetPort: +data.TargetPort,
        AppId: data.AppModel?.Id,
      },
      {
        onSuccess(data) {
          navigate(
            ROUTE_STRING.DOCKER_IMAGE.VIEW.replace(
              ':repository',
              data?.data?.ImageName,
            ),
          );
        },
      },
    );
  };

  return (
    <AppsContainer
      fullView
      title={
        <Breadcrumbs aria-label='breadcrumb' sx={{ mb: 2 }}>
          <Typography color='text.primary'>Library</Typography>
          <Typography color='text.primary'>
            <Link to={ROUTE_STRING.DOCKER_IMAGE.LIST}>Docker Repositories</Link>
          </Typography>
          <Typography color='text.primary'>Add</Typography>
        </Breadcrumbs>
      }
      sxStyle={{
        mb: '50px',
      }}
    >
      <AppsHeader>
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          sx={{ width: '100%' }}
        >
          <Box
            sx={{
              display: 'flex',
              cursor: 'pointer',
              alignItems: 'center',
              gap: 4,
            }}
            component='span'
            mr={{ xs: 2, sm: 4 }}
          >
            <AppTooltip title={<IntlMessages id='common.back' />}>
              <ArrowBackIcon
                sx={{
                  color: 'text.secondary',
                }}
                onClick={onClickBackButton}
              />
            </AppTooltip>
            <Typography variant='h4' sx={{ cursor: 'auto' }}>
              Add New
            </Typography>
          </Box>
        </Box>
      </AppsHeader>

      <Box p={4}>
        <Formik
          enableReinitialize
          validateOnChange={true}
          validateOnBlur={false}
          initialValues={{ DeploymentType: DockerAppTypes[0] }}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          {({ submitForm, values, setFieldValue, validateField, errors }) => (
            <AddDockerImageForm
              validateField={validateField}
              setForm={setFieldValue}
              submitForm={submitForm}
              onCancel={onClickBackButton}
              loading={addItem.isPending}
              values={values}
              errors={errors}
            />
          )}
        </Formik>
      </Box>
    </AppsContainer>
  );
};

export default React.memo(Add);
